import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { LOGO_URL, APPLICATION_URL } from '../constants/assets';

const { FiMenu, FiX, FiExternalLink } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white sticky top-0 z-50 border-b-4 border-mag-blue shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20 md:h-24">
          <Link to="/" className="flex items-center">
            <img 
              src={LOGO_URL}
              alt="MAG Insulation" 
              className="h-12 md:h-16 w-auto object-contain"
            />
          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-mag-black hover:text-mag-blue transition-colors font-black uppercase tracking-tight text-sm">
              Job Openings
            </Link>
            <a 
              href="https://maginsulation.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-mag-black hover:text-mag-blue transition-colors flex items-center space-x-1 font-black uppercase tracking-tight text-sm"
            >
              <span>Our Website</span>
              <SafeIcon icon={FiExternalLink} className="w-4 h-4" />
            </a>
            <a 
              href={APPLICATION_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-mag-green text-white px-8 py-3.5 rounded-lg hover:brightness-110 transition-all font-black text-sm uppercase tracking-wider shadow-md active:transform active:scale-95"
            >
              Apply Now
            </a>
          </nav>

          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden p-2 text-mag-black" aria-label="Toggle menu">
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-8 h-8" />
          </button>
        </div>
      </div>

      <AnimatePresence>
        {isMenuOpen && (
          <motion.div 
            initial={{ opacity: 0, height: 0 }} 
            animate={{ opacity: 1, height: 'auto' }} 
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white border-t border-gray-100 overflow-hidden"
          >
            <div className="flex flex-col space-y-4 p-6">
              <Link to="/" className="text-mag-black font-black uppercase text-lg border-b border-gray-50 pb-2" onClick={() => setIsMenuOpen(false)}>Job Openings</Link>
              <a href="https://maginsulation.com" className="text-mag-black font-black uppercase text-lg border-b border-gray-50 pb-2">Main Website</a>
              <a href={APPLICATION_URL} target="_blank" rel="noopener noreferrer" className="bg-mag-green text-white px-4 py-5 rounded-xl text-center font-black uppercase tracking-widest text-lg shadow-lg">Apply Now</a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;